module.exports = __webpack_public_path__ + "media/pt_br_s1_Francisca.7f0ceeff.mp3";